
import { defineComponent, useContext, useMeta } from '@nuxtjs/composition-api'
export default defineComponent({
  props: {
    error: {
      type: Object,
      default: null,
    },
  },
  head: {},
  setup(props) {
    const {
      app: { i18n },
    } = useContext()

    const pageStr = 'error'

    let errorStatusCode = 'code' + props.error.statusCode

    if (props.error.statusCode !== 404) {
      errorStatusCode = 'codeunknown'
    }

    useMeta(() => ({
      title: i18n.t(pageStr + '.' + errorStatusCode + '.title'),
      description: i18n.t(pageStr + '.' + errorStatusCode + '.description'),
    }))

    return { pageStr, i18n }
  },
})
